import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';
import { THEME } from './util/ui/theme';

import store from './store';

// Containers
import Layout from './layout';
import PreviewMenu from './layout/preview-menu';
import CategoryLayout from './layout/category-layout';

if ( document.getElementById( 'astra-sites-grid' ) ) {
	ReactDOM.render(
		<Provider store={ store }>
			<ThemeProvider theme={ THEME }>
				<Layout />
			</ThemeProvider>
		</Provider>,
		document.getElementById( 'astra-sites-grid' )
	);
}

const catGrids = document.querySelectorAll( '.astra-sites-category-layout' );

// Creates the category sliders layout
catGrids.forEach( ( layout, index ) => {
	const category = layout.getAttribute( 'data-category' );
	const config = {
		categories: category?.split( ',' ).map( ( cat ) => cat.trim() ) || [],
		enabledShowExcerpt: layout.getAttribute( 'data-show-excerpt' ) !== 'false' ? true : false,
		title: layout.getAttribute( 'data-title' ),
		showAllUrl: layout.getAttribute( 'data-show-all-url' ),
		pageBuilder: layout.getAttribute( 'data-page-builder' ),
		showWithDesc: layout.getAttribute( 'data-show-with-desc' ) !== 'false' ? true : false,
	};

	ReactDOM.render(
		<Provider store={ store }>
			<ThemeProvider theme={ THEME }>
				<CategoryLayout config={ config } key={ index } />
			</ThemeProvider>
		</Provider>,
		layout
	);
} );

const previewButtonRoot = document.getElementById( 'astra-sites-single-template-live-preview' );

const previewMenuData = previewButtonRoot ? JSON.parse( previewButtonRoot.dataset?.menu_data ) : {};

ReactDOM.render(
	<PreviewMenu attrs={ previewMenuData.attrs } pageBuilders={ previewMenuData.page_builders } />,
	previewButtonRoot
);
